<div #universalDeviceCheckModal class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content border-radius-0">
      <div class="modal-header text-uppercase py-2 font-size-16">
        <div class="modal-title" i18n="@@app.incorrect_universal_devices">Incorrect universal devices</div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </div>
      <div class="modal-body">
        <p i18n="@@app.incorrect_devices_at_least_ref_or_enumber_need_to_be_filled">Device incorrect: At least Ref. Nr. or E. Nr. need to be filled.If you click OK that devices will be removed!</p>
      </div>
      <div class="modal-footer pt-1 border-0">
        <button type="button" (click)="onConfirmDelete()" class="btn btn-danger btn-lg text-uppercase border-rounded font-weight-normal mx-2" i18n="@@app.remove_device">Remove Device</button>
        <button type="button" appDisableMultipleClick class="btn btn-primary btn-lg text-uppercase border-rounded font-weight-normal mx-2"
                (click)="onConfirm()" i18n="@@app.ok">Ok</button>
      </div>
    </div>
  </div>
</div>
